import { queryOptions } from "@tanstack/react-query";
import { listSessions } from "../../lib/auth";
import { keys } from "../../lib/keys";
import { unwrapAuth } from "./auth-errors";

/** One of the signed-in user's sessions, as the panel renders it (ISO strings, like the API). */
export interface SessionRow {
  id: string;
  /** Needed to revoke the row — never rendered. */
  token: string;
  createdAt: string;
  expiresAt: string;
  ipAddress: string | null;
  userAgent: string | null;
}

const iso = (value: unknown): string =>
  value instanceof Date ? value.toISOString() : String(value ?? "");

/** The user's active sessions, newest first (the current one is hoisted by the panel). */
export const sessionsQuery = queryOptions({
  queryKey: keys.sessions,
  queryFn: async (): Promise<SessionRow[]> => {
    const rows = unwrapAuth(await listSessions());
    return rows
      .map((s) => ({
        id: s.id,
        token: s.token,
        createdAt: iso(s.createdAt),
        expiresAt: iso(s.expiresAt),
        ipAddress: s.ipAddress ?? null,
        userAgent: s.userAgent ?? null,
      }))
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  },
});
